import React, { Component } from 'react';
import Bordereau from '../bordereau';

class BAct extends Component {
  render() {
    return (
      <Bordereau
        type="act"
        active={10}
        changeActiveItemSideBar={this.props.changeActiveItemSideBar}
        changeNamePage={this.props.changeNamePage}
        changeActiveItemSideBarCompta={this.props.changeActiveItemSideBarCompta}
      />
    );
  }
}

export default BAct;
